var _polygon, _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmailSent = function SvgEmailSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    width: 367.94101,
    height: 367.94101,
    viewBox: "0 0 367.94101 367.94101",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "360.002 7.92 248.002 359.92 175.602 192.32 360.002 7.92",
    opacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.138,135.392l164.456,63.192,71.064,164.512a8.01051,8.01051,0,0,0,7.344,4.824c.136,0,.264,0,.4-.008a8.00412,8.00412,0,0,0,7.224-5.56l112-352a7.60166,7.60166,0,0,0,.16-1.112,7.19029,7.19029,0,0,0,.152-1.104,7.79591,7.79591,0,0,0-.296-2.28c-.048-.168-.008-.344-.064-.512-.008-.032-.04-.056-.048-.088a8.06068,8.06068,0,0,0-1.464-2.52,7.49981,7.49981,0,0,0-.712-.624,7.66883,7.66883,0,0,0-1.184-1.024c-.112-.064-.24-.08-.352-.136A7.93425,7.93425,0,0,0,362.77.536a7.964,7.964,0,0,0-1.696-.464,7.30117,7.30117,0,0,0-1.112-.048,7.87364,7.87364,0,0,0-1.88.248c-.216.056-.432.008-.648.08l-352,120a7.99463,7.99463,0,0,0-.296,15.04Zm241.72,201.72-61.76-142.976L342.402,36.824Zm83.16-310.52L173.626,182.984,31.482,128.368Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.002,367.92a7.97807,7.97807,0,0,0,5.656-2.344l112-112a7.9988,7.9988,0,0,0-11.312-11.312l-112,112A8,8,0,0,0,8.002,367.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.346,298.264l-56,56a7.9988,7.9988,0,1,0,11.312,11.312l56-56a7.9988,7.9988,0,0,0-11.312-11.312Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.002,279.92a7.97807,7.97807,0,0,0,5.656-2.344l56-56a7.99879,7.99879,0,0,0-11.312-11.312l-56,56A8,8,0,0,0,8.002,279.92Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emailSent.fb43d674.svg";
export { ForwardRef as ReactComponent };